// @/components/reusable/page-wrapper.jsx
// V2 Page Wrapper Component with consistent padding and animation

import React from "react";
import clsx from "clsx";
import * as motion from "motion/react-client";

// ============================================================================
// ANIMATION CONFIG
// ============================================================================

import { spring } from "./animations";

// ============================================================================
// PAGE WRAPPER
// ============================================================================

/**
 * PageWrapper - Consistent page container with padding and fade-in animation
 *
 * Standard padding: p-8 sm:p-10 md:p-12 (32px, 40px, 48px)
 * Animation: Fade in with spring physics
 */
const PageWrapper = ({ children, className, noPadding = false, ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ...spring, delay: 0.05 }}
      className={clsx(
        "w-full max-w-full overflow-x-hidden",
        !noPadding && "p-8 sm:p-10 md:p-12 pb-0!",
        className
      )}
      {...props}
    >
      {children}
    </motion.div>
  );
};

// ============================================================================
// EXPORTS
// ============================================================================

export { PageWrapper };
export default PageWrapper;
